import React, { useState } from 'react';
import { Box, Modal } from '@nimbus-ds/components';
import { FormField } from '@nimbus-ds/patterns';
import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';
import CancelAndConfirmButtons from 'commons/components/CancelAndConfirmButtons';
import type { ProductsFromImages } from '../../NewProductFromImagesPage';

interface EditProductModalProps {
  product: ProductsFromImages[0];
  onDismiss: () => void;
  onConfirm: (product: ProductsFromImages[0]) => void;
}

function EditProductModal({
  product,
  onDismiss,
  onConfirm,
}: Readonly<EditProductModalProps>) {
  const { t } = useTranslation(Domain.CATALOG);

  // Local state for name and description
  const [localName, setLocalName] = useState(product.name);
  const [localDescription, setLocalDescription] = useState(product.description);

  const handleNameChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setLocalName(e.target.value);
  };

  const handleDescriptionChange = (
    e: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    setLocalDescription(e.target.value);
  };

  const handleConfirm = () => {
    onConfirm({
      ...product,
      name: localName,
      description: localDescription,
    });
    onDismiss();
  };

  return (
    <Modal open onDismiss={onDismiss}>
      <Modal.Header
        padding="small"
        title={t('products.fromImages.resultsTable.editProduct')}
      />
      <Modal.Body padding="small">
        <Box display="flex" flexDirection="column" gap="4">
          <FormField.Textarea
            id="editing-name-textarea"
            label={t('products.fromImages.resultsTable.productName')}
            value={localName}
            onChange={handleNameChange}
            placeholder={t('products.fromImages.resultsTable.productName')}
            lines={3}
          />
          <FormField.Textarea
            id="editing-description-textarea"
            label={t('products.fromImages.resultsTable.description')}
            value={localDescription}
            onChange={handleDescriptionChange}
            placeholder={t('products.fromImages.resultsTable.description')}
            lines={5}
          />
        </Box>
      </Modal.Body>
      <Modal.Footer>
        <CancelAndConfirmButtons
          onCancel={onDismiss}
          onConfirm={handleConfirm}
        />
      </Modal.Footer>
    </Modal>
  );
}

export default EditProductModal;
